import React, {useState, useEffect} from 'react';
import {getSearchBrandingText} from "../../organisms/property/helpers/search_helper";


const BrandingText = ({skeleton, content, searchParams, showDefaultIfNull = true}) => {
    const [widget, setWidget] = useState(content ?? null)

    useEffect(() => {
        if (!skeleton) {
            getSearchBrandingText(searchParams, showDefaultIfNull).then(widget => {
                setWidget(widget)
            })
        }
    }, [skeleton, searchParams]);


    if (widget) {
        return (
            <React.Fragment>
                <h2 className="mb-8">{widget.caption}</h2>
                <div dangerouslySetInnerHTML={{__html: widget.content}}/>
            </React.Fragment>
        );
    }

    return <></>
};

export default React.memo(BrandingText);
